import { UsePostApi } from "beaktShared/services/crudeApiService";
import { TIPO_CONTRATO } from "beaktMatriz/views/Credenciamento/Steps/ContratoEstabelecimentoService.js";

// BKT-1512: dashboards de contratos a vencer/vencidos por tipo (API: ?tipo=0 Renovação [padrão] | 1 Geral).
// todos = 0 traz a lista completa; outro valor traz o top 5 (regra da API).
const TIPOS_CONTRATO_DASHBOARD = [
    { value: TIPO_CONTRATO.RENOVACAO, label: "accreditation.renewal_contract" },
    { value: TIPO_CONTRATO.GERAL, label: "accreditation.general_contract" },
];

// Retorna { ok, data, message }; data sempre é array (lista vazia em erro ou sessão expirada)
const consultar = (rota, franquiaId, todos, tipo) =>
    Promise.resolve(UsePostApi(`dashboard/${rota}/${franquiaId}/${todos}?tipo=${tipo}`, null)).then(result => {
        if (!result)
            return { ok: false, data: [], message: "" };
        const ok = result.status === 200;
        const message = result.message && typeof result.message === "object"
            ? result.message.message
            : result.message;
        return { ok, data: ok && Array.isArray(result.data) ? result.data : [], message: message || "" };
    });

const getContratosAVencer = (franquiaId, todos, tipo = TIPO_CONTRATO.RENOVACAO) =>
    consultar("contratosavencer", franquiaId, todos, tipo);

const getContratosVencidos = (franquiaId, todos, tipo = TIPO_CONTRATO.RENOVACAO) =>
    consultar("contratosvencidos", franquiaId, todos, tipo);

export { TIPOS_CONTRATO_DASHBOARD, getContratosAVencer, getContratosVencidos };
